export default {
  title: 'Incidents',
  description: 'Incident management system',
  create: 'Create Incident',
  noResults: 'No incidents found',
  stats: {
    total: 'Total',
    open: 'Open',
    inProgress: 'In Progress',
    resolved: 'Resolved',
    closed: 'Closed',
    critical: 'Critical',
    high: 'High'
  },
  filters: {
    status: 'Status',
    severity: 'Severity',
    category: 'Category'
  },
  fields: {
    title: 'Title',
    status: 'Status',
    severity: 'Severity',
    category: 'Category',
    productionLine: 'Production Line',
    reportedBy: 'Reported By',
    reportedAt: 'Reported At',
    assignedTo: 'Assigned To',
    description: 'Description'
  },
  status: {
    open: 'Open',
    in_progress: 'In Progress',
    resolved: 'Resolved',
    closed: 'Closed'
  },
  severity: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical'
  },
  category: {
    quality: 'Quality',
    safety: 'Safety',
    equipment: 'Equipment',
    process: 'Process',
    other: 'Other'
  },
  sort: {
    'reportedAt-desc': 'Most Recent',
    'reportedAt-asc': 'Oldest',
    'severity-desc': 'Severity (High to Low)',
    'severity-asc': 'Severity (Low to High)',
    'title-asc': 'Title (A-Z)',
    'title-desc': 'Title (Z-A)'
  },
  kanban: {
    noIncidents: 'No incidents'
  },
  view: {
    list: 'List view',
    kanbanStatus: 'Kanban by status',
    kanbanSeverity: 'Kanban by severity'
  }
}
